<ng-container *ngIf="highcharts && chartOptions">
  <highcharts-chart
    [Highcharts]="highcharts"
    [options]="chartOptions"
    style="width: 100%; height: 400px; display: block"
  ></highcharts-chart>
</ng-container>
